/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	payment: {
		complete: false,
		enabled: true,
		paymentType: 'finance', // default
		total: null
	},
	tradeIn: {
		complete: false,
		enabled: true,
		total: null
	},
	protectionPlans: {
		complete: false,
		enabled: true,
		total: null
	},
	creditStatus: {
		complete: false,
		enabled: true,
		approved: false
	},
	testDrive: {
		complete: false,
		enabled: true
	},
	dealXgId: null
};

const stepsSlice = createSlice({
	name: 'steps',
	initialState,
	reducers: {
		setSteps(state, action) {
			return action.payload;
		},
		setPayment(state, action) {
			state.payment = action.payload;
		},
		setTradeIn(state, action) {
			state.tradeIn = action.payload;
		},
		setProtectionPlans(state, action) {
			state.protectionPlans = action.payload;
		},
		setCreditStatus(state, action) {
			state.creditStatus = action.payload;
		},
		setTestDrive(state, action) {
			state.testDrive = action.payload;
		},
		setDealXgId(state, action) {
			state.dealXgId = action.payload;
		},
		setPaymentAndType(state, action) {
			if (state.payment) {
				state.payment.total = action.payload.total;
				state.payment.paymentType = action.payload.paymentType;
			}
		},
		setPaymentComplete(state, action) {
			if (state.payment) {
				state.payment.complete = action.payload;
			}
		},
		setTradeInComplete(state, action) {
			if (state.tradeIn) {
				state.tradeIn.complete = action.payload;
			}
		},
		setProtectionPlansComplete(state, action) {
			if (state.protectionPlans) {
				state.protectionPlans.complete = action.payload;
			}
		},
		setCreditStatusComplete(state, action) {
			if (state.creditStatus) {
				state.creditStatus.complete = action.payload;
			}
		},
		setTestDriveComplete(state, action) {
			if (state.testDrive) {
				state.testDrive.complete = action.payload;
			}
		}
	}
});

export const {
	setSteps,
	setPayment,
	setTradeIn,
	setProtectionPlans,
	setCreditStatus,
	setTestDrive,
	setDealXgId,
	setPaymentAndType,
	setPaymentComplete,
	setTradeInComplete,
	setProtectionPlansComplete,
	setCreditStatusComplete,
	setTestDriveComplete
} = stepsSlice.actions;

export { initialState };

export default stepsSlice.reducer;
